export default __webpack_public_path__ + "static/media/people-flying-rafiki.62ad6829.png";